export default "__VITE_ASSET__ByrNMHoP__"